module.exports = __webpack_public_path__ + "static/media/qris-logo.48f4eb3e.svg";